// inv/src/pages/solutions/accelerators-incubators/blocks/AcceleratorsResearchSection.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../../../../components/ui/CTAHover';
import { CheckCircle2 } from 'lucide-react';

const AcceleratorsResearchSection = ({ bgColor = 'bg-slate-50' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-16 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 gap-16 items-center">
        <div className="order-2 lg:order-1">
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t(
              'pageSolutions.AcceleratorsIncubators.t11',
              'Give founders the deal intelligence they need to raise confidently'
            )}
          </h3>
          <h2 className="text-3xl sm:text-4xl font-semibold text-stone-900">
            {t(
              'pageSolutions.AcceleratorsIncubators.t12',
              'Understand how investors deploy capital in relevant sectors'
            )}
          </h2>

          <p className="mt-6 text-base leading-7 text-stone-700">
            {t(
              'pageSolutions.AcceleratorsIncubators.t13',
              'Crino highlights deal history, valuation ranges, sectors and geographies investors favour — helping founders tailor their outreach.'
            )}
          </p>

          <ul className="mt-6 space-y-4 text-base leading-7 text-stone-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t14',
                  'Review recent deals and analyse patterns across sectors, co-investors and geographies.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t15',
                  'Spot investors who repeatedly back startups similar to those in your cohort.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t16',
                  'Use AI to generate personalised outreach recommendations for each founder.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.AcceleratorsIncubators.t17',
                  'Track investor engagement with a simple CRM designed for fundraising workflows.'
                )}
              </span>
            </li>
          </ul>

          <CTAHover
            className="mt-8"
            text={t(
              'pageSolutions.AcceleratorsIncubators.t18',
              'Analyse investors and match them with your startups'
            )}
            href="find-investors/"
            align="left"
            bgColor="bg-amber-300 text-stone-800"
            textColor="text-stone-800"
            hoverTextColor="text-stone-800"
          />
        </div>

        <div className="order-1 lg:order-2 mb-12 lg:mb-0">
          <img
            className="w-full"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/solutions/crino-find-investors-filters.png"
            alt={t(
              'pageSolutions.AcceleratorsIncubators.alt2',
              'Deal history and investor analysis dashboard for accelerators'
            )}
          />
        </div>
      </div>
    </section>
  );
};

export default AcceleratorsResearchSection;
